import { combineReducers } from "@reduxjs/toolkit";
import details from "./userSlice";

const user = combineReducers({
  details,
});

export default user;
